import { status } from '@otto-ec/global-resources/debug';
import { EventData, eventQBus } from '@otto-ec/global-resources/event-q-bus';
import { TrackingQBusEvents } from '@otto-ec/tracking-bct';

type TrackingData = EventData[0];

export class TrackingEventEmitter {
    /**
     * @deprecated Not completely typesafe, use emitTrackingEvent function from common package instead
     */
    public emitTrackingEvent(topicName: keyof TrackingQBusEvents, trackingData: TrackingData, eventMergeId?: string): void {
        TrackingEventEmitter.emitTracking(topicName, trackingData, eventMergeId);
        TrackingEventEmitter.logDebug(`ft5 funk tracking sent event ${topicName}`, trackingData, eventMergeId);
    }

    private static emitTracking(trackingEvent: keyof TrackingQBusEvents, trackingData: TrackingData, eventMergeId: string | undefined) {
        if (eventMergeId) {
            eventQBus.emit(trackingEvent, trackingData, eventMergeId);
        } else {
            eventQBus.emit(trackingEvent, trackingData);
        }
    }

    // TODO: use debug module instead
    private static logDebug(message: string, trackingData: TrackingData, eventMergeId: string | undefined) {
        const isDebugMode = status() && status().activated;
        if (isDebugMode) {
            if (eventMergeId) {
                console.log(message, trackingData, eventMergeId);
            } else {
                console.log(message, trackingData);
            }
        }
    }
}
